<template>
	<div>
		<BaseHeader :title="$t('page_not_found').toString()" />
	</div>
</template>

<script>
import BaseHeader from '@/components/navigation/BaseHeader';
export default {
	name: 'PageNotFound',
	components: { BaseHeader },
};
</script>

<style scoped></style>
